import React, { Component } from "react";

class FileInput extends Component {
  render() {
    const {
  		input: { onChange, onBlur },
  	 	meta: omitMeta,
      adaptEvent,
  		...props
  	 } = this.props;
    return (
      <input
				onChange={adaptEvent(onChange)}
				onBlur={adaptEvent(onBlur)}
				type="file"
				{...props.input}
				{...props}
        ref="FileInput"
			/>
    );
  }
};

export default FileInput;



// WEBPACK FOOTER //
// ./src/components/ImageSelector/FileInput.js